import React from 'react';
import NotificationsIcons from '../../icons/NotificationsIcons';
import type { EventReminders as Reminders } from '../../../types/integrations';

interface EventRemindersProps {
  reminders: Reminders | null | undefined;
}

const formatMinutes = (min: number): string => {
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const r = min % 60;
  if (r === 0) return `${h} hr`;
  return `${h} hr ${r} min`;
};

const EventReminders: React.FC<EventRemindersProps> = ({ reminders }) => {
  if (!reminders?.overrides?.length) return null;
  return (
    <div className="flex items-start gap-3">
      <NotificationsIcons className="w-5 h-5 text-text-tertiary mt-0.5 shrink-0" />
      <div className="flex-1 min-w-0 text-sm text-text-secondary">
        {reminders.overrides.map((r, i) => (
          <p key={i}>
            {r.method === 'email' ? 'Email' : 'Notification'} · {formatMinutes(r.minutes)} before
          </p>
        ))}
      </div>
    </div>
  );
};

export default EventReminders;
